'use strict';

var MarketTDChartDowFilterFactory = function MarketTDChartDowFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartDowFilter() {
    DemandFilter.call(this, 'market', 'thematic-demand-chart-any-dow');
    this.registerFilters(injectedFilters);
  }
  TDChartDowFilter.constructor = TDChartDowFilter;
  TDChartDowFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartDowFilter;
};
MarketTDChartDowFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketTDChartDowFilterFactory;